'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nonNegativeInteger = {};

exports.__exports = nonNegativeInteger;
